<template>
  <div id="glossary">
    <h1>アイルランドのダンスクラス</h1>

    <h2>お断り</h2>
    <span class="md-body-1">このページはセットダンスをアイルランドで学びたい方向けに、アイルランドのサマースクールやセットダンシングウィーケンドについて城が見聞きしたり調べたものをまとめたものです。情報の正確さなどは保障できません。あくまで渡愛時の参考程度に使用してください。誤りなどありましたら城までご連絡ください。</span>

    <br />
    <br />

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">ウィリー・クランシー・サマー・スクール（英：Willie Clancy Summer School）</div>
        <div class="md-subhead">開催地：クレア州ミルタウン（英：Miltown, County Clare）</div>
        <div class="md-subhead">開催期間：7月の第一土曜日から約1週間</div>
      </md-card-header>

      <md-card-content>
        クレア州の西海岸ミルタウン・マルベイで開催されるアイルランドで最大規模のサマースクール。開催時期は7月の第一土曜日から約1週間。楽器・ダンスでそれぞれクラスが午前中に開かれる。期間中は1日に2回ケーリーが開かれる。会場はスパニッシュ・ポイント海岸のアルマダ・ホテル（英：Almada Hotel）とミルタウン市街から近いミル・マーキー（英：Mil Marquee）。ミルタウン市街では日中から深夜にかけてセッションも毎夜開かれる。
      </md-card-content>

      <md-card-header>
        <div class="md-subhead">Official Website：<a href="http://www.scoilsamhraidhwillieclancy.com/" target=_blank>http://www.scoilsamhraidhwillieclancy.com/</a></div>
        <div class="md-subhead">Facebook Page：<a href="https://www.facebook.com/willie.clancyweek/" target=_blank>https://www.facebook.com/willie.clancyweek/</a></div>
      </md-card-header>

    </md-card>

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">サウス・スライゴー・サマースクール（英語：South Sligo Summer School）</div>
        <div class="md-subhead">開催地：スライゴー州タバカリー（英：Tubbercurry, County Sligo）</div>
        <div class="md-subhead">開催期間：Willie Clancy Summer School後の約1週間</div>
      </md-card-header>

      <md-card-content>
        2018年のセットダンス・クラスの講師はPat Murphy。午前中にクラスがあり、地方のセットであるSouth Sligo LancersやTubbercurry Lancersなどが踊られるとか。もちろん夜にはケーリー。
      </md-card-content>

      <md-card-header>
        <div class="md-subhead">Official Website：<a href="http://www.sssschool.org/" target=_blank>http://www.sssschool.org/</a></div>
        <div class="md-subhead">Facebook Page：<a href="https://www.facebook.com/south.sligo.5/" target=_blank>https://www.facebook.com/south.sligo.5/</a></div>
      </md-card-header>

    </md-card>

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">ジョー・ムーニー・サマー・スクール（英語：Joe Mooney Summer School）</div>
        <div class="md-subhead">開催地：レイトゥリム州ドラムシャンボー（英語：Drumshanbo County Leitrim）</div>
        <div class="md-subhead">開催期間：South Sligo Summer School後の約1週間</div>
      </md-card-header>

      <md-card-content>

2018年のセットダンス・クラスの講師はPat MurphyとCatherine Curran。他のサマースクールと同様、午前中にクラス、夜にケーリー。
      </md-card-content>

      <md-card-header>
        <div class="md-subhead">Official Website：<a href="http://joemooneysummerschool.com/" target=_blank>http://joemooneysummerschool.com/</a></div>
        <div class="md-subhead">Facebook Page：<a href="https://www.facebook.com/JoeMooneySummerSchool/" target=_blank>https://www.facebook.com/JoeMooneySummerSchool/</a></div>
      </md-card-header>

    </md-card>

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">コニー・ライアン・セット・ダンシング・ウィーケンド（英語：Connie Ryan Set Dancing Weekend）</div>
        <div class="md-subhead">開催地：ティペラリー州ネナー（英語：Nenagh, County Tipperary）</div>
        <div class="md-subhead">開催期間：毎年1月中旬の3日間</div>
      </md-card-header>

      <md-card-content>
        Pat Murphyの師であるセット・ダンシング・マスター、Connie Ryanの名を冠したSet Dancing Weekend。近年は中野CCEの方々が毎年行かれているそうです。
      </md-card-content>

      <md-card-header>
        <div class="md-subhead">Official Website：<a href="https://www.abbeycourt.ie/set-dancing-weekend.html" target=_blank>https://www.abbeycourt.ie/set-dancing-weekend.html</a></div>
      </md-card-header>

    </md-card>

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">コニー・ライアン・ダブリン・ダンシング（英語： Connie Ryan Dublin Dancing）</div>
        <div class="md-subhead">開催地：ダブリン州ダブリン（英語：Dublin, County Dublin）</div>
        <div class="md-subhead">開催期間：1月中旬の3日間</div>
      </md-card-header>

      <md-card-content>
        同じくConnie Ryanの名を冠したSet Dancing Weekend。Connie Ryan主催で1980年初頭に始まり、彼の死後も現在に至るまで続いている。「コニー・ライアンを偲ぶ会」とも呼ばれる。2018年を除いて毎年開催。コニー・ライアンに縁のある人やバンドが集まる。マラハイドのGrand Hotel、Red Cow Moran Hotelから会場を移し、2019年はGreen Isle Hotelで開催された。オールド・ステップやシャンノース、セットダンスなど6つのワークショップと4回のケーリー。スムース・ステップが上手い人が集うという噂も。
      </md-card-content>

      <md-card-header>
        <div class="md-subhead">Facebook Page：<a href="https://www.facebook.com/events/393225507753248/" target=_blank>https://www.facebook.com/events/393225507753248/</a></div>
      </md-card-header>

    </md-card>


    <!-- <i class="material-icons">star</i> -->

    <!-- <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">Set Dancing News</div>
        <div class="md-subhead">http://setdanceteacher.ie</div>
      </md-card-header>

      <md-card-content>
        Bill Lynch氏が運営しているおそらくSet Dance界で一番のウェブサイト。ヨーロッパ各地のセットダンスクラスやケーリーの情報が掲載されている。
      </md-card-content>

      <md-card-actions>
        <md-button>開く</md-button>
      </md-card-actions>
    </md-card> -->

    <!-- DanceMinder
    https://danceminder.com/
    Set DanceだけでなくSiege of Ennisなどの様々なダンスが掲載されている。

    Irish Set Dancing
    http://setdanceteacher.ie/
    DanceMinderで見つからないときはこちら。

    Set Dancing News
    http://sets.ie/
    Bill Lynch氏が運営しているおそらくSet Dance界で一番のウェブサイト。ヨーロッパ各地のセットダンスクラスやケーリーの情報が掲載されている。

    Irish Bliss
    http://irishbliss.org/
    EASY IRISH DANCEというウェブサイトを運営しているNoraさんのブログ。アイルランドのSummer Schoolの情報やセットの人気投票などが掲載されている。

    Irish Set Dance Music Database
    http://mabula.net:8000/setmusic/
    バーズ(Bars)やリズムで曲を探せるサイト。「踊りたいけれど曲がない…」という時に便利。 -->

    <md-divider></md-divider>

    <span class="md-caption">copyright © 2017-{{ new Date().getFullYear() }} Hiroshi Jo</span>

  </div>
</template>

<script>
// import db from '../db'

export default {
  name: 'set',
  data () {
    return {
      error: null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

h2 {
  margin-top: 48px;
}

a {
  color: #42b983;
}

.md-divider {
  margin: 32px 0 8px 0;
}
</style>



// WEBPACK FOOTER //
// EventOfIreland.vue?72fd32dd